export default input => {
  if (input.length === 5 || input.length === 10)
    return true;
  return false;
}